'use client';

import React from 'react';
import { sectionHeadingTag } from '@/components/dynamic-zone/section-heading-level';
import { cn } from '@/lib/utils';
import { components } from '@/types/strapi';

// interface TableRow {
// 	descriptiontion: string;
// 	value: number;
// 	remarks: string;
// }
// export interface TableProps {
// 	title?: string;
// 	description?: string;
// 	headers: string[];
// 	rows: TableRow[];
// 	className?: string;
// }

export const Table = ({
	title,
	description,
	headers,
	rows,
}: components['schemas']['DynamicZoneDynamicTableComponent']) => {
	return (
		<div
			className={cn(
				'dynamic-table-section mx-auto w-full max-w-6xl px-4',
			)}>
			<noscript>
				<style>{`
					.dynamic-table-section table,
					.dynamic-table-section th,
					.dynamic-table-section td {
						opacity: 1 !important;
						visibility: visible !important;
					}
				`}</style>
			</noscript>
			<div className="overflow-x-auto">
				<table className="w-full border-collapse overflow-hidden rounded-lg bg-white shadow-lg">
					{(title || description) && (
						<caption className="mb-8 caption-top text-center">
							{title && (
								<span className="block text-3xl font-bold">
									{title}
								</span>
							)}
							{description && (
								<span className="mt-4 block text-lg text-gray-600">
									{description}
								</span>
							)}
						</caption>
					)}
					<thead>
						{headers && (
							<tr className="bg-blue-700 text-white">
								<th className="px-6 py-4 text-left font-semibold">
									{headers.column1}
								</th>
								<th className="px-6 py-4 text-left font-semibold">
									{headers.column2}
								</th>
								<th className="px-6 py-4 text-left font-semibold">
									{headers.column3}
								</th>
							</tr>
						)}
					</thead>
					<tbody>
						{rows?.map((row, index) => (
							<tr
								key={index}
								className={cn(
									'border-t border-gray-200',
									index % 2 === 0 ? 'bg-white' : 'bg-gray-50',
								)}>
								<td className="px-6 py-4">{row.column1}</td>
								<td className="px-6 py-4">{row.column2}</td>
								<td className="px-6 py-4 text-gray-600">
									{row.column3}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
